const visualCategoryLinksConfig = {
  3606: [
    {
      friendlyName: "Puffer Jackets",
      linkUrl:
        "men/jackets-coats/puffer-jackets/cat/?cid=28642&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-puffer-jacket-with-detachable-hood-in-black/200275340-3"
    },
    {
      friendlyName: "Overcoats",
      linkUrl: "men/jackets-coats/overcoats/cat/?cid=20990&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-overcoat-in-grey-check/202955383-1-charcoal"
    },
    {
      friendlyName: "Gilets",
      linkUrl: "men/jackets-coats/gilets/cat/?cid=14886&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-cord-puffer-gilet-in-brown/202821961-1-brown"
    },
    {
      friendlyName: "Parkas",
      linkUrl: "men/jackets-coats/parkas/cat/?cid=12931&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-parka-jacket-with-funnel-neck-in-khaki/23979057-2"
    },
    {
      friendlyName: "Bomber Jackets",
      linkUrl:
        "men/jackets-coats/bomber-jackets/cat/?cid=16245&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-bomber-jacket-with-ma1-pocket-in-washed-pink/200914055-1-pink"
    },
    {
      friendlyName: "Trench Coats",
      linkUrl:
        "men/jackets-coats/trench-coats/cat/?cid=11902&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-wool-look-trench-coat-in-beige/202448338-2"
    },
    {
      friendlyName: "Smart Coats",
      linkUrl: "men/jackets-coats/smart-coats/cat/?cid=29394&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-shower-resistant-double-breasted-trench-coat-in-stone/11219797-3"
    },
    {
      friendlyName: "Leather Jackets",
      linkUrl:
        "men/jackets-coats/leather-jackets/cat/?cid=11760&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-real-leather-biker-jacket-in-black/202993671-4"
    },
    {
      friendlyName: "Shackets",
      linkUrl: "men/jackets-coats/shackets/cat/?cid=50080&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-longline-wool-look-shacket-in-off-white/202450442-1-ivory"
    },
    {
      friendlyName: "Denim Jackets",
      linkUrl:
        "men/jackets-coats/denim-jackets/cat/?cid=11908&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-denim-jacket-in-light-stone/200904911-4"
    }
  ],
  4208: [
    {
      friendlyName: "Slim Jeans",
      linkUrl: "men/jeans/slim-jeans/cat/?cid=5054&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-stretch-slim-jeans-in-mid-wash-blue/203095779-1-blue"
    },
    {
      friendlyName: "Skinny Jeans",
      linkUrl: "men/jeans/skinny-jeans/cat/?cid=5403&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-skinny-jeans-in-darkwash-blue/202685360-1-blue"
    },
    {
      friendlyName: "Straight Jeans",
      linkUrl: "men/jeans/straight-jeans/cat/?cid=5052&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-straight-jeans-in-washed-black/202697448-1-black"
    },
    {
      friendlyName: "Wide Jeans",
      linkUrl: "men/jeans/wide-jeans/cat/?cid=50030&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-straight-fit-jeans-in-midwash-blue/202684862-3"
    },
    {
      friendlyName: "Tapered Jeans",
      linkUrl: "men/jeans/tapered-jeans/cat/?cid=16982&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-stretch-tapered-jeans-in-dark-wash-blue/203096326-1-blue"
    },
    {
      friendlyName: "Ripped Jeans",
      linkUrl: "men/jeans/ripped-jeans/cat/?cid=19790&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-skinny-jeans-in-washed-black-with-heavy-rips/200449151-1-washedblack"
    },
    {
      friendlyName: "Loose Jeans",
      linkUrl: "men/jeans/loose-jeans/cat/?cid=5055&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-straight-leg-jeans-in-black/200212203-4"
    },
    {
      friendlyName: "Super Skinny Jeans",
      linkUrl: "men/jeans/super-skinny-jeans/cat/?cid=16463&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-spray-on-jeans-with-power-stretch-in-dark-wash-blue-with-abrasions/200448335-4"
    },
    {
      friendlyName: "Dark Wash Jeans",
      linkUrl: "men/jeans/dark-wash-jeans/cat/?cid=11059&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-jeans-in-dark-wash-blue/203096425-1-blue"
    },
    {
      friendlyName: "Light Wash Jeans",
      linkUrl: "men/jeans/light-wash-jeans/cat/?cid=50032&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-stretch-tapered-jeans-in-light-wash-blue-with-tint/203096095-2"
    }
  ],
  3630: [
    {
      friendlyName: "Mom Jeans",
      linkUrl: "women/jeans/mom-jeans/cat/?cid=20310&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/collusion-x006-mom-jean-in-mid-wash-blue/23518615-1-blue"
    },
    {
      friendlyName: "Flare Jeans",
      linkUrl: "women/jeans/flare-jeans/cat/?cid=11316&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-power-stretch-flared-jeans-in-dark-blue/202814125-1-darkblue"
    },
    {
      friendlyName: "High Waisted Jeans",
      linkUrl:
        "women/jeans/high-waisted-jeans/cat/?cid=15159&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slouchy-mom-jeans-in-washed-black/200441353-1-washedblack"
    },
    {
      friendlyName: "Straight Leg Jeans",
      linkUrl:
        "women/jeans/straight-leg-jeans/cat/?cid=50616&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/topshop-kort-jeans-in-bleach/200422807-1-bleach"
    },
    {
      friendlyName: "Cargo Jeans",
      linkUrl: "women/jeans/50774/cat/?cid=50774&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-ultimate-cargo-jeans-in-black-with-contrast-thread/203601536-1-black"
    },
    {
      friendlyName: "Skinny Jeans",
      linkUrl: "women/jeans/skinny-jeans/cat/?cid=10769&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-skinny-jeans-in-clean-black/21729809-1-black"
    },
    {
      friendlyName: "Wide Leg Jeans",
      linkUrl: "women/jeans/wide-leg-jeans/cat/?cid=28017&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-low-rise-baggy-boyfriend-jeans-with-knee-patches-in-mid-blue/203787202-1-midblue"
    },
    {
      friendlyName: "Slim Jeans",
      linkUrl: "women/jeans/slim-jeans/cat/?cid=15157&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/reclaimed-vintage-90s-high-waisted-slim-leg-jean-in-antique-wash/203279807-1-lightblue"
    },
    {
      friendlyName: "Ankle Grazer Jeans",
      linkUrl:
        "women/jeans/ankle-grazer-jeans/cat/?cid=19826&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/levis-ribcage-crop-jean-in-black/203226189-1-blackwornin"
    },
    {
      friendlyName: "Coated Jeans",
      linkUrl: "women/jeans/coated-jeans/cat/?cid=50773&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-ultimate-skinny-jeans-in-coated-taupe/202637395-1-taupe"
    }
  ],
  8799: [
    {
      friendlyName: "Party Dresses",
      linkUrl: "women/dresses/party-dresses/cat/?cid=11057&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asyou-mesh-insert-long-sleeve-velvet-mini-dress-in-black/203589479-3"
    },
    {
      friendlyName: "Evening Dresses",
      linkUrl: "women/dresses/evening-dresses/cat/?cid=8857&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-scoop-back-bias-cut-satin-maxi-dress-in-champagne/200276367-1-champagne"
    },
    {
      friendlyName: "Workwear Dresses",
      linkUrl:
        "women/dresses/workwear-dresses/cat/?cid=11464&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-long-sleeve-midi-dress-with-obi-belt-in-green/204139335-1-green"
    },
    {
      friendlyName: "Jumper Dresses",
      linkUrl: "women/dresses/jumper-dresses/cat/?cid=12686&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-knitted-jumper-mini-dress-in-charcoal/203630911-1-charcoal"
    },
    {
      friendlyName: "Dresses For Weddings",
      linkUrl:
        "women/dresses/dresses-for-weddings/cat/?cid=13934&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-satin-maxi-dress-with-batwing-sleeve-and-wrap-waist-in-rust/14156597-1-softrust"
    },
    {
      friendlyName: "Sequin Dresses",
      linkUrl: "women/dresses/sequin-dresses/cat/?cid=14543&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-edition-frill-sequin-smock-mini-dress-in-blush/202209598-1-blush"
    },
    {
      friendlyName: "Day Dresses",
      linkUrl: "women/dresses/day-dresses/cat/?cid=19680&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-super-soft-midi-wrap-jumper-dress-with-belt-in-forest-green/202878794-4"
    },
    {
      friendlyName: "Maxi Dresses",
      linkUrl: "women/dresses/maxi-dresses/cat/?cid=9979&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-supersoft-long-sleeve-cut-out-detail-maxi-dress-in-oatmeal/203381894-1-oatmeal"
    },
    {
      friendlyName: "Midi Dresses",
      linkUrl: "women/dresses/midi-dresses/cat/?cid=12899&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-knitted-midi-dress-with-tie-waist-in-taupe/202226120-2"
    },
    {
      friendlyName: "Bridesmaid Dresses",
      linkUrl:
        "women/dresses/bridesmaid-dresses/cat/?cid=15156&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-bridesmaid-cami-maxi-dress-with-ruched-bodice-and-tie-waist-in-dusty-mauve/201279957-1-dustymauve"
    }
  ],
  26090: [
    {
      friendlyName: "Gym & Training",
      linkUrl: "men/sportswear/gym-training/cat/?cid=27183&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-muscle-fit-training-hoodie-with-quick-dry/200363580-1-khaki"
    },
    {
      friendlyName: "Tops",
      linkUrl: "men/sportswear/tops/cat/?cid=27181&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-long-sleeve-training-t-shirt-with-1-4-zip/200360964-1-red"
    },
    {
      friendlyName: "Shorts",
      linkUrl: "men/sportswear/shorts/cat/?cid=27178&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-training-shorts-in-mid-length-with-quick-dry-in-khaki/203186875-1-khaki"
    },
    {
      friendlyName: "Shoes",
      linkUrl: "men/sportswear/shoes/cat/?cid=27179&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asics-running-gt-1000-11-trainers-in-black/201413334-1-black"
    },
    {
      friendlyName: "Trousers & Tights",
      linkUrl:
        "men/sportswear/trousers-tights/cat/?cid=27177&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-training-skinny-jogger/201300390-1-navy"
    },
    {
      friendlyName: "Running",
      linkUrl: "men/sportswear/running/cat/?cid=27191&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-muscle-fit-running-jacket/200792789-1-blackgrey"
    },
    {
      friendlyName: "Ski & Snowboard",
      linkUrl: "men/sportswear/ski-snowboard/cat/?cid=27520&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-ski-headband/203221395-1-black"
    },
    {
      friendlyName: "Accessories",
      linkUrl: "men/sportswear/accessories/cat/?cid=27176&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-training-headband-in-white/12812758-1-white"
    },
    {
      friendlyName: "Football",
      linkUrl: "men/sportswear/football/cat/?cid=27182&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-football-dri-fit-fc-long-sleeve-t-shirt-in-green/201453705-1-green"
    },
    {
      friendlyName: "Outdoors",
      linkUrl: "men/sportswear/outdoors/cat/?cid=27184&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/berghaus-deluge-pro-20-insulated-jacket-in-black/24116405-1-jetblack"
    }
  ],
  26091: [
    {
      friendlyName: "Accessories",
      linkUrl: "women/sportswear/accessories/cat/?cid=27162&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-training-gym-club-20-holdall-in-grey/202325341-1-grey"
    },
    {
      friendlyName: "Leggings",
      linkUrl: "women/sportswear/leggings/cat/?cid=27163&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-legging-with-bum-sculpt-seam-detail-and-pocket/203083682-1-black"
    },
    {
      friendlyName: "Tops",
      linkUrl: "women/sportswear/tops/cat/?cid=27167&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-performance-t-shirt-in-oxblood/202302490-1-oxblood"
    },
    {
      friendlyName: "Gym & Training",
      linkUrl: "women/sportswear/gym-training/cat/?cid=27171&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-curve-all-sports-long-sleeve-top-with-back-seam-detail/203063996-3"
    },
    {
      friendlyName: "Sports Bras",
      linkUrl: "women/sportswear/sports-bras/cat/?cid=27168&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-low-impact-sports-bra-with-skinny-branded-strap/201229956-1-cream"
    },
    {
      friendlyName: "Shoes",
      linkUrl: "women/sportswear/shoes/cat/?cid=27165&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-running-renew-ride-3-trainers-in-black-and-white/200936521-4"
    },
    {
      friendlyName: "Running",
      linkUrl: "women/sportswear/running/cat/?cid=27172&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-long-sleeve-run-top/200250311-1-khaki"
    },
    {
      friendlyName: "Shorts",
      linkUrl: "women/sportswear/shorts/cat/?cid=27164&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-hourglass-icon-booty-legging-short-with-bum-sculpt-detail/201977500-3"
    },
    {
      friendlyName: "Yoga & Studio",
      linkUrl: "women/sportswear/yoga-studio/cat/?cid=27175&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-curve-icon-yoga-legging/200245897-2"
    },
    {
      friendlyName: "Ski & Snowboard",
      linkUrl:
        "women/sportswear/ski-snowboard/cat/?cid=27519&ctaref=cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-ski-belted-jacket-with-faux-fur-hood/202572967-1-white"
    }
  ]
};

export default visualCategoryLinksConfig;
